import React, { useState, useEffect } from 'react';
import { EditOutlined, CopyOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { Button, message, Tooltip, Checkbox } from 'antd';
import { isValidArrayWithValues, isValid, checkActionAllowed } from '../../utils/utilities';
import './edit-fare-modal.style.scss';

export const EditFareModal = (props) => {
    const {
        selectedSeats = [],
        onFareChange,
        disabled = false,
        showEditFare =false
    } = props;

    
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [seatFares, setSeatFares] = useState([]);
    const [isVip, setIsVip] = useState(false);

    useEffect(() => {
        if (isValidArrayWithValues(selectedSeats)) {
            const initialFares = selectedSeats.map(seat => ({
                seatId: seat.id,
                seatNumber: seat.seatNumber,
                fare: seat.discountedCostWithoutGst || seat.fare || 0,
                originalFare: seat.discountedCostWithoutGst || seat.fare || 0
            }));
            setSeatFares(initialFares);
        }
    }, [selectedSeats]);

    const showModal = () => {
        if (!disabled && isValidArrayWithValues(selectedSeats)) {
            const currentFares = selectedSeats.map(seat => ({
                seatId: seat.id,
                seatNumber: seat.seatNumber,
                fare: seat.discountedCostWithoutGst || seat.fare || 0,
                originalFare: seat.discountedCostWithoutGst || seat.fare || 0
            }));
            setSeatFares(currentFares);
            setIsVip(false);
            setIsModalVisible(true);
        }
    };

    const handleCancel = () => {
        const originalFares = selectedSeats.map(seat => ({
            seatId: seat.id,
            seatNumber: seat.seatNumber,
            fare: seat.discountedCostWithoutGst || seat.fare || 0,
            originalFare: seat.discountedCostWithoutGst || seat.fare || 0
        }));
        setSeatFares(originalFares);
        setIsVip(false);
        setIsModalVisible(false);
    };

    const handleSave = () => {
        if (onFareChange && typeof onFareChange === 'function') {
            const invalidFare = seatFares.find(sf => !isValid(sf.fare) || sf.fare < 0);
            if (invalidFare && !isVip) {
                message.error('Please enter valid fare for all seats');
                return;
            }
            onFareChange(seatFares, isVip);
        }
        setIsModalVisible(false);
    };

    const handleFareChange = (seatId, newFare) => {
        if (isVip) {
            return; // Don't allow fare changes when VIP is selected
        }
        const value = parseFloat(newFare) || 0;
        setSeatFares(prevFares => 
            prevFares.map(sf => 
                sf.seatId === seatId ? { ...sf, fare: value } : sf
            )
        );
    };

    const handleVipChange = (e) => {
        const checked = e.target.checked;
        setIsVip(checked);
        if (checked) {
            // Set all fares to 0 when VIP is checked
            setSeatFares(prevFares =>
                prevFares.map(sf => ({ ...sf, fare: 0 }))
            );
        } else {
            // Restore original fares when VIP is unchecked
            setSeatFares(prevFares =>
                prevFares.map(sf => ({ ...sf, fare: sf.originalFare }))
            );
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target.classList.contains('simple-modal-backdrop')) {
            handleCancel();
        }
    };

    const copyFirstFareToAll = () => {
        if (seatFares.length > 0) {
            const firstFare = seatFares[0].fare;
            setSeatFares(prevFares => 
                prevFares.map(sf => ({ ...sf, fare: firstFare }))
            );
            message.success('Fare copied to all seats');
        }
    };

    if (!isValidArrayWithValues(selectedSeats) || !showEditFare) {
        return  <strong className='text'>Fare</strong>
    }

    return (
        <div>
            <span 
                className={`edit-fare-trigger ${disabled ? 'disabled' : ''}`}
                onClick={showModal}
                title="Click to edit fare"
            >
                <strong className='text'>Fare</strong><EditOutlined className="edit-fare-icon" />
            </span>

            {isModalVisible && (
                <div className="simple-modal-backdrop" onClick={handleBackdropClick}>
                    <div className="simple-modal">
                        <div className="simple-modal-header">
                            <h3>Edit Fare</h3>
                            <Tooltip title="Copy first seat fare to all">
                                <Button className="copy-down-btn" onClick={copyFirstFareToAll}>
                                    <CopyOutlined />
                                    <ArrowDownOutlined />
                                </Button>
                            </Tooltip>
                        </div>

                        <div style={{ padding: '16px', borderBottom: '1px solid #f0f0f0' }}>
                            <Checkbox checked={isVip} onChange={handleVipChange}>
                                VIP
                            </Checkbox>
                        </div>

                        <div className="simple-modal-body">
                            <div className="fare-table">
                                <div className="fare-table-header">
                                    <span>Seat #</span>
                                    <span>Fare</span>
                                </div>
                                
                                {seatFares.map((seatFare, index) => (
                                    <div key={seatFare.seatId || index} className="fare-table-row">
                                        <span className="seat-number">{seatFare.seatNumber}</span>
                                        <div className="fare-input-wrapper">
                                            <span className="currency">₹</span>
                                            <input
                                                type="number"
                                                value={seatFare.fare}
                                                min={0}
                                                onChange={(e) => handleFareChange(seatFare.seatId, e.target.value)}
                                                disabled={isVip}
                                                className="fare-input"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="simple-modal-footer">
                            <Button className="btn-cancel" onClick={handleCancel}>
                                Cancel
                            </Button>
                            <Button className="btn-save" onClick={handleSave}>
                                Save
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EditFareModal;

